import { IUser } from "../../../core/types/base/IUser";

export const GlobalAdminRole = "Global Administrator";
const isGlobalAdmin = (user?: IUser | null): boolean => !!user?.roles?.includes(GlobalAdminRole);

export { isGlobalAdmin };
